// import { AddSupplierAccountRequestComponent } from './../../components/add-supplier-account-request/add-supplier-account-request.component';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GetSupplierAccountRequestsService } from '../../services/get-supplier-account-requests.service';

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {
/* --------------------------------- Fields --------------------------------- */
  filterForm = this.fb.group({
    limit: [50, [Validators.required]],
    offset: [0, [Validators.required]]
  })
  filterSubject = new BehaviorSubject<any>(this.filterForm)
  displayedColumns: string[] = ['sNo', 'supplier_name', 'name', 'email', 'phone'];

  dataSource : MatTableDataSource<any>;
  totalElements = 0;

  constructor(
    private _dialog: MatDialog,
    private fb: FormBuilder,
    private getSupplierAccountRequestsService: GetSupplierAccountRequestsService
  ) { }

  ngOnInit(): void {
    this.filterSubject.pipe(switchMap(filterData=>{
      return this.getSupplierAccountRequestsService.getSupplierAccountRequests(filterData)
    })).subscribe(([supplier_accounts, totalElements]: [any, number])=>{
      console.log(totalElements);
      this.dataSource = new MatTableDataSource<any>(supplier_accounts);
      this.totalElements = totalElements;
    });
  }

  get limit(){
    return this.filterForm.get('limit');
  }
  get offset(){
    return this.filterForm.get('offset');
  }
  changePage(ev: PageEvent){
    this.offset.setValue(ev.pageIndex * ev.pageSize);
    this.filterSubject.next(this.filterForm.value);
  }
}

